module.exports = __webpack_public_path__ + "static/img/access-helpful-videos.e440f9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/access-helpful-videos.png
// module id = 5LRs
// module chunks = 0